<template lang="pug">
  section.shipping-tracking(v-if="shipments.length")
    h5.font-weight-bold.mb-3 包裹配送進度
    article.shipment-card(v-for="shipment in shipments" :key="shipment.id")
      .shipment-summary
        div
          .label 出貨來源
          strong {{ sourceLabel(shipment) }}
        div
          .label 黑貓包裹查詢號碼
          strong {{ lookupNumber(shipment) }}
        .status {{ shipment.latest_status_text || '物流資料準備中' }}
      p.updated(v-if="automaticSync") 自動同步：每日 00:30、06:30、12:30、18:30（台灣時間）
      ol.timeline
        li(v-for="event in shipment.events || []" :key="`${event.id}-${event.occurred_at}`")
          .dot
          .event-body
            strong {{ event.status_text || `貨態代碼 ${event.status_code}` }}
            span(v-if="event.office_name") {{ event.office_name }}
            time {{ formatTime(event.occurred_at) }}
      p.empty(v-if="!shipment.events || !shipment.events.length") 目前尚無配送進度。
      p.updated(v-if="shipment.last_synced_at") 最後同步時間：{{ formatTime(shipment.last_synced_at) }}
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'ShippingTrackingTimeline',
  props: {
    shipments: { type: Array, default: () => [] },
    automaticSync: { type: Boolean, default: true }
  },
  methods: {
    lookupNumber(shipment) {
      return /^9[0-9]{11}$/.test(shipment.lookup_number || '') ? shipment.lookup_number : '尚未取得'
    },
    sourceLabel(shipment) {
      if (shipment.source_type === 'store') return shipment.source_name || '營業所郵寄訂單'
      if (shipment.source_type === 'online') return '修改網購訂單'
      return '來源待確認'
    },
    formatTime(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.shipping-tracking { margin: 24px 0; }
.shipment-card { border: 1px solid #d7e4de; border-radius: 8px; padding: 18px; margin-bottom: 16px; background: #fff; }
.shipment-summary { display: grid; grid-template-columns: 1fr 1fr auto; gap: 16px; align-items: center; padding-bottom: 16px; border-bottom: 1px solid #e7ece9; }
.label, .updated { color: #6c757d; font-size: 14px; }
.status { color: #176b50; background: #edf7f3; border-radius: 18px; padding: 7px 14px; font-weight: bold; }
.timeline { list-style: none; margin: 18px 0 0; padding: 0; }
.timeline li { display: flex; position: relative; padding: 0 0 20px 24px; }
.timeline li:not(:last-child)::before { content: ''; position: absolute; left: 6px; top: 13px; bottom: -2px; width: 2px; background: #c7ded4; }
.dot { position: absolute; left: 0; top: 5px; width: 14px; height: 14px; border-radius: 50%; background: #16845f; }
.event-body { display: flex; flex-wrap: wrap; gap: 6px 14px; }
.event-body strong { width: 100%; }
.event-body span, .event-body time { color: #58636d; }
.empty { margin: 16px 0 0; color: #6c757d; }
.updated { margin: 4px 0 0; text-align: right; }
@media (max-width: 767px) {
  .shipment-summary { grid-template-columns: 1fr; }
  .status { justify-self: start; }
}
</style>
